import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class UTTaskMemoListItem extends SearchModelBase {
    asigned: string = '';
    remindDate: string | null = null;
    fromRemindDate: string | null = null;
    toRemindDate: string | null = null;
    dueDate: string | null = null;
    fromDueDate: string | null = null;
    toDueDate: string | null = null;
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    createdBy: string = '';
    refNo: string = '';
    title: string = '';
    contents: string = '';
    tbName: string = '';
    tbId: string = '';
    id: number = 0;
    opType: string = '';
    acctType: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Task', width: 50, dataIndex: 'task', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true, defaultColumnFocus:true}),
        XCol.Create({ col: 2, text: 'Assigned', width: 100, dataIndex: 'asigned'}),
        XCol.Create({ col: 3, text: 'Remind Date', width: 130, dataIndex: 'remindDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, formatString: ' hh:mm'}),
        XCol.Create({ col: 4, text: 'Due Date', width: 130, dataIndex: 'dueDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, formatString: ' hh:mm'}),
        XCol.Create({ col: 5, text: 'Pending', width: 50, dataIndex: 'pending', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 6, text: 'Type', width: 150, dataIndex: 'opType',align: XCol.XAlignType.Center}),
        XCol.Create({ col: 6, text: 'Reference', width: 200, dataIndex: 'refNo'}),
        XCol.Create({ col: 7, text: 'Subject', width: 200, dataIndex: 'title'}),
        XCol.Create({ col: 8, text: 'Memo', width: 540, dataIndex: 'contents'}),
        XCol.Create({ col: 9, text: 'Create Date', width: 80, dataIndex: 'createdAt', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 10, text: 'Create By', width: 100, dataIndex: 'createdBy'}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
      return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: UTTaskMemoListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: UTTaskMemoListItem[]) {
        return data.map((d: UTTaskMemoListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
      dueDate: {from: 'fromDueDate', to: 'toDueDate'},
      createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
      remindDate: {from: 'fromRemindDate', to: 'toRemindDate'},
    }
}
